import { GetPlayerCumulativeResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerCumulative } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerCumulative(
	playerId: string,

	props?: Partial<UseBaseQueryOptions<GetPlayerCumulativeResponse>>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerCumulative, playerId],
		queryFn: () => getPlayerCumulative(playerId),
		...props,
	})
}
